<template>
  <div id="AccountStreams" class="Main-Content">

    <LoadingLayout v-if="loading" :page="true" />

    <StreamEditor
      v-else
      :locale="$i18n.locale"
      :authKey="sessionKey"
      :api="apiCalls"
      :currentId="currentId"
      :productRecommendations="productRecommendations"
      @update:current-id="setCurrentId"
    />
    
  </div>
</template>

<script>

import StreamEditor from '../apps/streamApp/App'

export default {
  name: 'AccountStreams',
  data () {
    return {
      sessionKey: null,
      productRecommendations: false,
      loading: true,
      apiCalls: null
    }
  },
  mounted() {
    NProgress.start()
    Promise.all([this.api.getCurrentAccountPrefs(), this.api.getSessionKey()])
      .then((response) => {
        let [ prefs, sessionKey ] = response 
        this.productRecommendations = prefs.recommendationsEnabled
        this.sessionKey = sessionKey
        this.apiCalls = this.getApi()
        this.loading = false
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
  },  
  computed: {
    currentId() {
      const id = parseInt(this.$route.params.streamId)
      return isNaN(id) ? null : id
    }
  },
  methods: {
    setCurrentId(id) {
      if (!id || id === -1) {
        this.$router.push({ name: 'AccountStreams' })
      }
      else if (this.currentId !== id) {
        this.$router.push({ name: 'AccountStreamsID', params: { streamId: id } })
      }
      
    },
    getApi() {
      const self = this
      return {
        getStreams() {
          return self.api.getStreams()
        },
        getStreamById(id) {
          return self.api.getStream(id)
        },
        setStreamDisabledById(id, isDisabled) {
          return self.api.setStreamDisabled(id, isDisabled)
        },
        archiveStreamById(id) {
          return self.api.archiveStream(id)
        },
        saveStream(stream) {
          return self.api.saveStream(stream)
        }
      }
    }
  },
  components: {
    StreamEditor
  }
}

</script>
